import React from 'react';
import clsx from 'clsx';
import classes from './Tag.module.scss';
import tagConfigs from './tagConfigs';
import Tooltip from 'components/atoms/Tooltip/Tooltip';
import Txt from 'components/atoms/Txt/Txt';
import type { OfferType } from 'utils/offers';

export interface TagProps {
  tag: string;
  type: OfferType | 'survey';
  className?: string;
  showDetails?: boolean;
}

const Tag: React.FC<TagProps> = function Tag({
  tag,
  type,
  showDetails = false,
  className,
  ...rest
}) {
  const config = tagConfigs[type][tag];
  if (!config) return null;

  if (showDetails) {
    return (
      <div className={clsx(classes.tagDetails, className)} {...rest}>
        <config.Icon />
        <div>
          <Txt component="h4" className={classes.tagTitle}>
            {config.title}
          </Txt>
          <Txt component="p" className={classes.tagDescription}>
            {config.description}
          </Txt>
        </div>
      </div>
    );
  }

  return (
    <Tooltip
      tipClassName={classes.tip}
      tip={
        <div className={classes.tagContent}>
          <Txt component="h4" className={classes.tagTitle}>
            {config.title}
          </Txt>
          <Txt component="p" className={classes.tagDescription}>
            {config.description}
          </Txt>
        </div>
      }
      {...rest}
    >
      <config.Icon className={classes.icon} />
    </Tooltip>
  );
};

export default Tag;
